import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceV2 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

	return <div className="ltn__feature-area pt-90 pb-90 go-top">
			<div className="container">
			<div className="row">
				<div className="col-lg-12">
				<div className="section-title-area ltn__section-title-2--- text-center">
					<h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">features</h6>
					<h1 className="section-title">Core Features</h1>
				</div>
				</div>
			</div>
			<div className="row ltn__custom-gutter">
				<div className="col-lg-3 col-sm-6 col-12">
				<div className="ltn__feature-item ltn__feature-item-6">
					<div className="ltn__feature-icon">
					<span><i className="flaticon-apartment" /></span>
					</div>
					<div className="ltn__feature-info">
					<h4><Link to="/service-details">Performance</Link></h4>
					<p>We ensure maintainability, reliability, and flexibility in our services so that we can provide you with high-quality performance.</p>
					</div>
				</div>
				</div>
				<div className="col-lg-3 col-sm-6 col-12">
				<div className="ltn__feature-item ltn__feature-item-6 active">
					<div className="ltn__feature-icon">
					<span><i className="flaticon-park" /></span>
					</div>
					<div className="ltn__feature-info">
					<h4><Link to="/service-details">ECO friendly</Link></h4>
					<p>Quality meets eco-friendly solutions: energy-efficient upgrades and maintenance for a positive impact. </p>
					</div>
				</div>
				</div>
				<div className="col-lg-3 col-sm-6 col-12">
				<div className="ltn__feature-item ltn__feature-item-6">
					<div className="ltn__feature-icon">
					<span><i className="flaticon-maps-and-location" /></span>
					</div>
					<div className="ltn__feature-info">
					<h4><Link to="/service-details">Customer Service</Link></h4>
					<p>We offer you customer service which will be an easy and enjoyable experience to expand your business.</p>
					</div>
				</div>
				</div>
				<div className="col-lg-3 col-sm-6 col-12">
				<div className="ltn__feature-item ltn__feature-item-6">
					<div className="ltn__feature-icon">
					<span><i className="flaticon-excavator" /></span>
					</div>
					<div className="ltn__feature-info">
					<h4><Link to="/service-details">Budget Friendly</Link></h4>
					<p>By using simple and inexpensive techniques, we can customize our services according to the client's requirements..</p>
					</div>
				</div>
				</div>
			</div>
			</div>
		</div>
  
        }
}

export default ServiceV2